import Model from "backdraft-app/src/model";

export default class FieldValuePair extends Model {
}
